export default class DdcData {
  birthdate = "";

  hash = "";
}
